<div class="mobile-menu-overlay" [class.active]="isMenuOpen()" (click)="closeMenu()">
  <div class="menu-content" (click)="$event.stopPropagation()">
    <div class="smm-container flex flex-column justify-content-between">
      <nav class="mobile-nav flex flex-column gap-4">
        @for (nav of navs; track $index) {
          <a (click)="navigate(nav.fragment)" class="nav-link caption__standard">
            {{ nav.label | translate }}
          </a>
        }
      </nav>

      <div class="menu-footer border-top-neutral flex flex-column gap-3 mb-4">
        <div class="flex gap-4 align-items-center between">
          <a
            href="https://app.echoza.ai/signup"
            target="_blank"
            rel="noopener noreferrer"
            class="primary-btn w-full highlight__accent"
            (click)="closeMenu()"
          >
            {{ 'BUTTONS.BOOK_A_DEMO' | translate }}
          </a>
          <a
            href="https://app.echoza.ai/login"
            target="_blank"
            class="login-link highlight__accent secondary-btn w-full"
            rel="noopener noreferrer"
          >
            {{ 'BUTTONS.LOGIN' | translate }}
          </a>
        </div>

        <div class="flex gap-3 align-items-center justify-content-end">
          <span class="lang-toggle highlight__accent" (click)="toggleLang()">
            {{ 'BUTTONS.LANG' | translate }}
          </span>
          <img
            [src]="
              currentTheme() === 'dark' ? '/imgs/icons/light-mode.png' : '/imgs/icons/dark-mode.png'
            "
            class="theme-icon cursor-pointer"
            (click)="toggleTheme()"
          />
        </div>
      </div>
    </div>
  </div>
</div>
